module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity7.3d5614d8.jpg";